import { SETTINGS } from '../../config/settings';

export const COMPANIES = '/companies';
export const PUBLICATIONS = '/publications';
export const HOME = '/home';

export const COMPANY = (companyId: string) => `${COMPANIES}/${companyId}`;

export const COMPANY_ESTABLISHMENTS = (companyId: string) =>
  `${COMPANY(companyId)}/establishments`;

export const COMPANY_CURRENT_ESTABLISHMENT = (
  companyId: string,
  establishmentId: string,
) => `${COMPANY_ESTABLISHMENTS(companyId)}/${establishmentId}`;

export const COMPANY_ESTABLISHMENTS_NEW = (companyId: string) =>
  `${COMPANY_ESTABLISHMENTS(companyId)}/new`;

export const COMPANY_ESTABLISHMENT_EDIT = (
  companyId: string,
  establishmentId: string,
) => `${COMPANY_CURRENT_ESTABLISHMENT(companyId, establishmentId)}/edit`;

export const COMPANY_ESTABLISHMENT_IMAGE = (
  companyId: string,
  establishmentId: string,
) => `${COMPANY_CURRENT_ESTABLISHMENT(companyId, establishmentId)}/image`;

export const COMPANY_ESTABLISHMENTS_CONTACTS_NEW = (
  companyId: string,
  establishmentId: string,
) =>
  `${COMPANY_CURRENT_ESTABLISHMENT(companyId, establishmentId)}/contacts/new`;

export const COMPANY_ESTABLISHMENTS_CONTACTS_EDIT = (
  companyId: string,
  establishmentId: string,
) =>
  `${COMPANY_CURRENT_ESTABLISHMENT(companyId, establishmentId)}/contacts/edit`;

export const COMPANY_ESTABLISHMENTS_HOURS_NEW = (
  companyId: string,
  establishmentId: string,
) => `${COMPANY_CURRENT_ESTABLISHMENT(companyId, establishmentId)}/hours/new`;

export const COMPANY_ESTABLISHMENTS_HOURS_EDIT = (
  companyId: string,
  establishmentId: string,
  hourId: string,
) =>
  `${COMPANY_CURRENT_ESTABLISHMENT(
    companyId,
    establishmentId,
  )}/hours/${hourId}/edit`;

export const COMPANIES_PUBLICATIONS = (companyId: string) =>
  `${COMPANIES}/${companyId}/publications`;

export const COMPANIES_PUBLICATIONS_NEW = (companyId: string) =>
  `${COMPANIES_PUBLICATIONS(companyId)}/new`;

export const PUBLICATION = (companyId: string, publicationId: string) =>
  `${COMPANIES_PUBLICATIONS(companyId)}/${publicationId}`;

export const PUBLICATIONS_SHOW = (publicationId: string) =>
  `/publications/${publicationId}`;

export const COMPANIES_PUBLICATIONS_EDIT = (
  companyId: string,
  publicationId: string,
) => `${PUBLICATION(companyId, publicationId)}/edit`;

export const PUBLICATIONS_DETAILS = (
  companyId: string,
  publicationId: string,
) => `${PUBLICATION(companyId, publicationId)}/details`;

export const PUBLICATIONS_ESTABLISHMENTS = (
  companyId: string,
  publicationId: string,
) => `${PUBLICATION(companyId, publicationId)}/establishments`;

export const PUBLICATIONS_IMAGES = (companyId: string, publicationId: string) =>
  `${PUBLICATION(companyId, publicationId)}/images/create`;

export const PARTNER_WEB_COMPANIES = `${SETTINGS.public.urlPartnerWeb}/companies`;

export const PARTNER_WEB_CURRENT_COMPANIES = (companyId: string) => `
  ${SETTINGS.public.urlPartnerWeb}/companies/${companyId}
`;

export const PARTNER_WEB_MODERATE_COMPANIES = (companyId: string) => `
  ${SETTINGS.public.urlPartnerWeb}/moderate/companies/${companyId}
`;

export const COMPANIES_PUBLICATIONS_MODERATE = (
  companyId: string,
  publicationId: string,
) => `/moderate/companies/${companyId}/publications/${publicationId}`;

export const PUBLICATIONS_MODERATE = () => `/moderate/publications`;
export const PUBLICATIONS_MODERATE_SEARCH = `/moderate/publications/search`;
export const PUBLICATIONS_MODERATE_DETAILS = (publicationId: string) =>
  `${PUBLICATIONS_MODERATE()}/${publicationId}`;

export const PUBLICATIONS_MODERATE_FILTER = (query: string) =>
  `${PUBLICATIONS_MODERATE()}/filter${query}`;

export const SEARCH = '/publications/search';

export const PUBLICATIONS_CATEGORY_FILTER = (categoryId: string) =>
  `/publications/category/${categoryId}/filter`;

export const CATEGORIES = `/moderate/categories`;

export const CATEGORIES_NEW = `${CATEGORIES}/new`;

export const CATEGORIES_EDIT = (id: string) => `${CATEGORIES}/${id}/edit`;
